import { Data, Puck } from '@measured/puck';
import { PuckHeader } from './puck-header';
import { PuckPreview } from './puck-preview';
import { PuckFields } from './puck-fields';
import { useExternalConfig } from '@/features/populate/hooks/use-external-config';
import { useEffect } from 'react';
import { RootNode } from '@/features/populate/hooks/use-load-puck-data';
import '@measured/puck/puck.css';

function save() {}

export interface PuckEditorProps {
  isLoading: boolean;
  onSave: (data: Data, rootNode?: RootNode, adminTitle?: string) => void;
}

export function PuckEditor({ onSave, isLoading }: PuckEditorProps) {
  const config = useExternalConfig();

  if (!config) {
    return null;
  }

  const script = document.createElement('script');
  script.src = 'https://cdn.tailwindcss.com';
  script.async = true;
  document.head.appendChild(script);

  const script2 = document.createElement('script');
  //script2.src = 'https://components.dyta.app/index-DakLUNxJ.js';
  //script2.src = 'https://components.dyta.app/index-C3xO-wvx.js';
  script2.src = import.meta.env.VITE_DYTA_COMPONENTS_URL ?? 'https://components.dyta.app/index-CZ_zC4t5.js';
  
  script2.async = true;
  document.head.appendChild(script2);

  console.log("*************************hi");

  document.defaultView!.DYTA_CONFIG = {
    apiBaseUrl: import.meta.env.VITE_DYTA_CONFIG_API_BASE_URL,
    identityServerUrl: import.meta.env.VITE_DYTA_CONFIG_IDENTITY_SERVER_URL,
    clientId: import.meta.env.VITE_DYTA_CONFIG_CLIENT_ID,
    defaultContainerUuid: import.meta.env.VITE_DYTA_CONFIG_DEFAULT_CONTAINER_UUID,
  };

  document.defaultView!.DYTA_CONFIG_CS = {
    apiBaseUrl: import.meta.env.VITE_DYTA_CONFIG_CS_API_BASE_URL,
    identityServerUrl: import.meta.env.VITE_DYTA_CONFIG_CS_IDENTITY_SERVER_URL,
    clientId: import.meta.env.VITE_DYTA_CONFIG_CS_CLIENT_ID,
    defaultContainerUuid: import.meta.env.VITE_DYTA_CONFIG_CS_DEFAULT_CONTAINER_UUID,
  };

  /*
  if (!document.querySelector('dyta-master')) {
    const container = document.createElement('dyta-master');
    document.body.appendChild(container);
  }
  */

  return (
    <Puck
      config={config.editor}
      data={{}}
      onPublish={save}
      iframe={{ enabled: false }}
      overrides={{
        iframe: ({ children, document }) => {
          useEffect(() => {
            if (document) {
              const existing = Array.from(
                document.head.querySelectorAll('script')
              ).find((s) => s.src === src);

              if (!existing) {
                const script = document.createElement('script');
                script.src = 'https://cdn.tailwindcss.com';
                script.async = true;
                document.head.appendChild(script);

                const script2 = document.createElement('script');
                //script2.src = 'https://components.dyta.app/index-DakLUNxJ.js';
                script2.src = 'https://components.dyta.app/index-C3xO-wvx.js';

                script2.async = true;
                document.head.appendChild(script2);

                document.defaultView!.DYTA_CONFIG = {
                  apiBaseUrl: 'https://api.dyta.app/api',
                  identityServerUrl: 'https://identity-2.dyta.app/realms/graph',
                  clientId: 'graph-react-local',
                  defaultContainerUuid: 'f9d9029f-d605-4bf9-94a2-a79cd88d7656',
                };

                const container = document.createElement('dyta-master');
                document.body.appendChild(container);
              }
            }
          }, [document]);

          return <>{children}</>;
        },
      }}
    >
      <PuckHeader onSave={onSave} isLoading={isLoading} />
      <div className="grid grid-cols-[300px,auto,300px] border border-slate-100">
        <div className="p-4">
          <Puck.Components />
        </div>
        <PuckPreview />
        <div className="p-4">
          <PuckFields uiSchema={config.uiSchema} />
        </div>
      </div>
    </Puck>
  );
}
